// 吃瓜视频网 - 本地内容数据（临时占位，后续可切换真实数据源）

export interface VideoItem {
  id: number;
  title: string;
  category: string;
  views: string;
  likes: string;
  comments: string;
  duration: string;
  hotTag?: string;
  image: string;
}

export interface CategoryItem {
  id: number;
  name: string;
  desc: string;
  count: string;
  icon: string;
  image: string;
}

export interface TopicItem {
  id: number;
  title: string;
  participants: string;
  heat: string;
  tag: string;
}

export interface DanmakuComment {
  id: number;
  text: string;
  color: string;
  lane: number;
}

export const videoCategories = ["全部", "影视吐槽", "综艺现场", "吃瓜前线", "社会热点", "直播讨论"];

export const hotVideos: VideoItem[] = [
  {
    id: 1,
    title: "综艺名场面复盘：这波操作真的绝了",
    category: "综艺现场",
    views: "286万",
    likes: "3.2万",
    comments: "1.8万",
    duration: "08:24",
    hotTag: "爆款",
    image: "https://readdy.ai/api/search-image?query=energetic%20young%20friends%20watching%20live%20show%20on%20couch%20cheering%20and%20laughing%2C%20warm%20coral%20and%20amber%20tones%2C%20cozy%20night%20living%20room%2C%20editorial%20lifestyle%20photography%2C%20soft%20cinematic%20lighting%20with%20high%20energy%20vibe&width=640&height=360&seq=video-01&orientation=landscape",
  },
  {
    id: 2,
    title: "吃瓜前线：当事人首次回应全过程",
    category: "吃瓜前线",
    views: "512万",
    likes: "6.7万",
    comments: "3.9万",
    duration: "12:03",
    hotTag: "沸",
    image: "https://readdy.ai/api/search-image?query=media%20crew%20with%20microphones%20at%20a%20press%20gathering%20at%20night%2C%20vivid%20orange%20and%20cream%20tones%2C%20news%20desk%20with%20warm%20spotlights%2C%20editorial%20photojournalism%2C%20dynamic%20composition%20with%20bokeh%20lights%20behind&width=640&height=360&seq=video-02&orientation=landscape",
  },
  {
    id: 3,
    title: "影视吐槽：这个反派智商掉线了？",
    category: "影视吐槽",
    views: "168万",
    likes: "2.1万",
    comments: "0.9万",
    duration: "15:47",
    image: "https://readdy.ai/api/search-image?query=cinema%20screen%20showing%20dramatic%20scene%20with%20popcorn%20and%20soda%20in%20foreground%2C%20warm%20amber%20cinema%20ambient%20light%2C%20cozy%20movie%20night%2C%20editorial%20still%20life%20photography%2C%20soft%20shadows&width=640&height=360&seq=video-03&orientation=landscape",
  },
  {
    id: 4,
    title: "社会热点解读：我们到底在围观什么",
    category: "社会热点",
    views: "96万",
    likes: "1.5万",
    comments: "0.6万",
    duration: "10:18",
    image: "https://readdy.ai/api/search-image?query=diverse%20group%20of%20people%20gathered%20around%20a%20smartphone%20discussing%20intensely%20at%20a%20cafe%2C%20warm%20terracotta%20and%20cream%20palette%2C%20candid%20documentary%20style%2C%20natural%20window%20light&width=640&height=360&seq=video-04&orientation=landscape",
  },
  {
    id: 5,
    title: "直播讨论：今晚谁才是最大赢家",
    category: "直播讨论",
    views: "342万",
    likes: "4.4万",
    comments: "2.5万",
    duration: "21:06",
    hotTag: "热议",
    image: "https://readdy.ai/api/search-image?query=live%20broadcast%20studio%20with%20colorful%20ring%20light%20and%20host%20desk%2C%20warm%20orange%20and%20amber%20stage%20lights%2C%20energetic%20online%20streaming%20setup%2C%20editorial%20technology%20photography&width=640&height=360&seq=video-05&orientation=landscape",
  },
  {
    id: 6,
    title: "综艺名场面：导师们集体破防瞬间",
    category: "综艺现场",
    views: "221万",
    likes: "2.8万",
    comments: "1.2万",
    duration: "06:55",
    image: "https://readdy.ai/api/search-image?query=large%20television%20stage%20with%20bright%20warm%20stage%20lights%20and%20audience%20silhouettes%20cheering%2C%20golden%20amber%20glow%2C%20live%20show%20atmosphere%2C%20editorial%20event%20photography&width=640&height=360&seq=video-06&orientation=landscape",
  },
  {
    id: 7,
    title: "吃瓜前线：后续反转再反转，看懵了",
    category: "吃瓜前线",
    views: "408万",
    likes: "5.6万",
    comments: "3.1万",
    duration: "09:32",
    hotTag: "沸",
    image: "https://readdy.ai/api/search-image?query=smartphone%20in%20hand%20showing%20colorful%20social%20feed%20with%20notifications%20popup%2C%20warm%20coral%20and%20cream%20tones%2C%20close%20up%2C%20lively%20digital%20news%20vibe%2C%20editorial%20photography&width=640&height=360&seq=video-07&orientation=landscape",
  },
  {
    id: 8,
    title: "影视吐槽：剧本这样写真的合理吗",
    category: "影视吐槽",
    views: "143万",
    likes: "1.9万",
    comments: "0.8万",
    duration: "13:26",
    image: "https://readdy.ai/api/search-image?query=retro%20television%20set%20with%20dramatic%20scene%20and%20vintage%20popcorn%20tray%2C%20warm%20amber%20and%20terracotta%20tones%2C%20nostalgic%20movie%20watching%2C%20editorial%20photography%20with%20soft%20light&width=640&height=360&seq=video-08&orientation=landscape",
  },
];

export const categories: CategoryItem[] = [
  {
    id: 1,
    name: "影视吐槽",
    desc: "追剧人的嘴替，一键看穿剧本套路",
    count: "1.2万条",
    icon: "ri-movie-2-line",
    image: "https://readdy.ai/api/search-image?query=tilted%20movie%20clapperboard%20and%20film%20reels%20on%20warm%20coral%20backdrop%2C%20playful%20cinema%20themed%20flat%20lay%2C%20energetic%20young%20vibe%2C%20editorial%20studio%20photography%2C%20soft%20shadows&width=480&height=560&seq=cat-01&orientation=portrait",
  },
  {
    id: 2,
    name: "综艺现场",
    desc: "名场面复盘，笑点泪点一把抓",
    count: "8.6千条",
    icon: "ri-tv-2-line",
    image: "https://readdy.ai/api/search-image?query=colorful%20variety%20show%20stage%20with%20golden%20confetti%20and%20spotlights%2C%20warm%20amber%20and%20cream%20tones%2C%20festive%20live%20entertainment%20atmosphere%2C%20editorial%20photography&width=480&height=560&seq=cat-02&orientation=portrait",
  },
  {
    id: 3,
    name: "吃瓜前线",
    desc: "第一手热点，围观永不缺席",
    count: "2.4万条",
    icon: "ri-flashlight-line",
    image: "https://readdy.ai/api/search-image?query=vintage%20watermelon%20slice%20with%20news%20headline%20paper%20and%20megaphone%20on%20warm%20terracotta%20backdrop%2C%20playful%20gossip%20news%20themed%20flat%20lay%2C%20editorial%20studio%20photography&width=480&height=560&seq=cat-03&orientation=portrait",
  },
  {
    id: 4,
    name: "社会热点",
    desc: "看懂热点背后的故事与脉络",
    count: "6.3千条",
    icon: "ri-earth-line",
    image: "https://readdy.ai/api/search-image?query=open%20newspaper%20with%20magnifying%20glass%20and%20coffee%20cup%20on%20warm%20cream%20desk%2C%20warm%20amber%20tones%2C%20thoughtful%20documentary%20vibe%2C%20editorial%20photography&width=480&height=560&seq=cat-04&orientation=portrait",
  },
  {
    id: 5,
    name: "直播讨论",
    desc: "边看边聊，弹幕就是第二现场",
    count: "9.1千条",
    icon: "ri-live-line",
    image: "https://readdy.ai/api/search-image?query=live%20streaming%20desk%20with%20microphone%20and%20warm%20ring%20light%20glow%2C%20coral%20and%20amber%20tones%2C%20energetic%20creator%20studio%2C%20editorial%20photography&width=480&height=560&seq=cat-05&orientation=portrait",
  },
  {
    id: 6,
    name: "弹幕热梗",
    desc: "全网热梗出处，一次看懂",
    count: "4.7千条",
    icon: "ri-chat-smile-3-line",
    image: "https://readdy.ai/api/search-image?query=flying%20speech%20bubbles%20and%20chat%20icons%20over%20warm%20peach%20gradient%20background%2C%20playful%20community%20conversation%20theme%2C%20bright%20energetic%20vibe%2C%20editorial%20illustration%20style&width=480&height=560&seq=cat-06&orientation=portrait",
  },
];

export const hotTopics: TopicItem[] = [
  { id: 1, title: "#今晚综艺谁封神#", participants: "18.6万围观", heat: "🔥 3.2亿热度", tag: "综艺" },
  { id: 2, title: "#影视剧最离谱设定#", participants: "9.4万围观", heat: "🔥 1.1亿热度", tag: "影视" },
  { id: 3, title: "#吃瓜第一现场#", participants: "26.1万围观", heat: "🔥 5.7亿热度", tag: "热点" },
  { id: 4, title: "#这段吐槽笑死我了#", participants: "12.3万围观", heat: "🔥 2.4亿热度", tag: "热梗" },
  { id: 5, title: "#导师们的名场面#", participants: "7.8万围观", heat: "🔥 0.9亿热度", tag: "综艺" },
  { id: 6, title: "#直播弹幕翻车现场#", participants: "15.2万围观", heat: "🔥 2.9亿热度", tag: "直播" },
];

export const initialDanmaku: DanmakuComment[] = [
  { id: 1, text: "前排围观！！", color: "#fff3d6", lane: 0 },
  { id: 2, text: "这也太顶了吧哈哈哈哈", color: "#ffe0b2", lane: 1 },
  { id: 3, text: "这操作我看不懂了", color: "#ffd0c2", lane: 2 },
  { id: 4, text: "弹幕护体", color: "#fff3d6", lane: 3 },
  { id: 5, text: "笑死我了哈哈哈哈", color: "#ffe0b2", lane: 0 },
  { id: 6, text: "反转了反转了！", color: "#ffd0c2", lane: 1 },
  { id: 7, text: "围观群众表示很满意", color: "#fff3d6", lane: 2 },
  { id: 8, text: "前排占座 坐等开瓜", color: "#ffd0c2", lane: 3 },
  { id: 9, text: "这瓜保熟吗？", color: "#ffe0b2", lane: 0 },
  { id: 10, text: "蚌埠住了", color: "#fff3d6", lane: 1 },
  { id: 11, text: "这期封神好吧", color: "#ffd0c2", lane: 2 },
  { id: 12, text: "弹幕给我整笑了", color: "#ffe0b2", lane: 3 },
];

export const hotTags = [
  "综艺名场面",
  "吃瓜前线",
  "影视吐槽",
  "社会热点",
  "弹幕热梗",
  "直播讨论",
  "反转现场",
  "评论区破防",
];